import request from '@/utils/request'
import {uuid} from 'vue-uuid'


export function getBeneficiaryByProject(project_id, currency){
  return request({
    url: `/api/transactions/${project_id}/${currency}`,
    method: "get"
  });
}

export function makePayment(data){
  data.idempotency = uuid.v1();
  return request({
    url: `/api/transactions`,
    method: "post",
    data: data
  });
}

export function getReturnFund(transaction_id){
  return request({
    url: `/api/transactions/${transaction_id}/returnfund`,
    method: "get"
  });
}

export function postReturnFund(transaction_id, data){
  data.idempotency = uuid.v1();
  return request({
    url: `/api/transactions/${transaction_id}/returnfund`,
    method: "post",
    data: data
  });
}

export function postClearBalance(bankholder_id, data){
  return request({
    url: `/api/transactions/${bankholder_id}/clearbalance`,
    method: "post",
    data: data
  });
}

export function getPending(ledger_id){
  return request({
    url: `/api/transactions/pending/list/${ledger_id}`,
    method: "get"
  });
}

export function updatePending(transaction_id){
  return request({
    url: `/api/transactions/pending/${transaction_id}`,
    method: "put"
  });
}

export function deletePending(transaction_id){
  return request({
    url: `/api/transactions/pending/${transaction_id}`,
    method: "delete"
  });
}
